import { CurrencyPipe, NgIf } from '@angular/common';
import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { OrderUpsell } from '@models/order-upsell';
import { StorageService } from '@services/storage.service';

@Component({
  selector: 'app-order-upsell-checkbox',
  imports: [NgIf, CurrencyPipe],
  templateUrl: './order-upsell-checkbox.component.html',
  styleUrl: './order-upsell-checkbox.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OrderUpsellCheckboxComponent {
  @Input({ required: true }) public test!: OrderUpsell;

  private readonly storageService = inject(StorageService);

  /**
   * Checks if the current test is in orderUpsells.
   *
   * @returns {boolean} true if the test is selected, false otherwise
   */
  public get isSelected(): boolean {
    return this.storageService.orderUpsells.some((upsell) => upsell.id === this.test.id);
  }

  /**
   * Toggles the selection state of the upsell.
   */
  public toggleCheckbox(): void {
    const currentOrderUpsells = this.storageService.orderUpsells;

    this.storageService.orderUpsells = this.isSelected
      ? currentOrderUpsells.filter((upsell) => upsell.id !== this.test.id)
      : [...currentOrderUpsells, this.test];
  }
}
